import React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { generateDailyPassword, getPasswordExpirationTime } from '~/utils/hash';
import { useReactiveDuration } from '../hooks/useReactiveDuration';
import styles from './styles';

export const Header = ({
  equipment, translate, classes,
}) => {
  const duration = useReactiveDuration(equipment?.start_timestamp);
  const unlockPassword = generateDailyPassword(equipment?.id_equip);
  const unlockPasswordExpired = getPasswordExpirationTime();

  return (
    <div className={classes.wrapperHeader}>
      <div className={classes.wrapperLabelHeader}>
        <Typography className={classes.labelHeader}>
          {translate('common:EquipmentSituation')}
          {':'}
          {' '}
          {equipment?.equip_name}
        </Typography>
      </div>
      <div className={classes.wrapperHeaderInfo}>
        <div className={classes.wrapperInfo}>
          <Typography className={classes.labelInfo}>{translate('common:EquipmentType')}</Typography>
          <Typography className={classes.valueInfo}>{equipment?.equip_type_name || ''}</Typography>
        </div>
        <div className={classes.wrapperInfo}>
          <Typography className={classes.labelInfo}>{translate('common:EquipmentGroup')}</Typography>
          <Typography className={classes.valueInfo}>{equipment?.equip_group_name || ''}</Typography>
        </div>
        <div className={classes.wrapperInfo}>
          <Typography className={classes.labelInfo}>{translate('common:Status')}</Typography>
          <Typography className={classes.valueInfo}>{equipment?.code_type_name || ''}</Typography>
        </div>
        <div className={classes.wrapperInfo}>
          <Typography className={classes.labelInfo}>{translate('common:Code')}</Typography>
          <Typography className={classes.valueInfo}>{equipment?.code_name || ''}</Typography>
        </div>
        <div className={classes.wrapperInfo}>
          <Typography className={classes.labelInfo}>{translate('common:UnlockPassword')}</Typography>
          <Typography className={classes.highlightValue}>
            {unlockPassword}
          </Typography>
          <Typography className={classes.valueInfo}>{`${translate('common:ValidUntil')}: ${unlockPasswordExpired}`}</Typography>
        </div>
        <div className={classes.wrapperInfo}>
          <Typography className={classes.labelInfo}>{translate('common:Duration')}</Typography>
          <Typography className={classes.valueInfo}>{duration}</Typography>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  equipment: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
